import { z } from "zod";

export const ContactFormSchema = z.object({
  name: z
    .string()
    .min(2, "Имя должно содержать не менее 2 символов")
    .max(50, "Имя должно содержать менее 50 символов")
    .regex(/^[a-zA-Zа-яА-Я\s-]+$/, "Имя содержит недопустимые символы"),
  phone: z.string().regex(/^\+?[1-9]\d{1,14}$/, "Недопустимый номер телефона"),
  email: z
    .string()
    .email({ message: "Некорректный email" })
    .min(1, { message: "Поле email обязательно" }),
  subject: z.string().min(1, { message: "Не выбрана тема" }).optional(),
  message: z
    .string()
    .max(100, { message: "Сообщение не должно превышать 100 символов" })
    .optional(),
});

export type ContactFormData = z.infer<typeof ContactFormSchema>;
